import { DashBoard } from '../Dashboard/Dashboard';

export const Home = () => {
  return (
    <>
      <DashBoard />
    </>
  );
};
